import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@app/material.module";
import { TranslateModule } from "@ngx-translate/core";
import { ReportsExportDialogComponent } from "./reports-export-dialog.component";

@NgModule({
	declarations: [ReportsExportDialogComponent],
	imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
	exports: [ReportsExportDialogComponent],
})
export class ReportsExportDialogModule {}
